import {useEffect, useState} from 'react'
import {Button, Dialog, DialogBackdrop, DialogPanel, TransitionChild} from '@headlessui/react'
import {
    ArrowRightEndOnRectangleIcon,
    Bars3Icon,
    ChartPieIcon, ChatBubbleLeftEllipsisIcon, ClipboardDocumentListIcon, CreditCardIcon,
    HomeIcon, ShoppingCartIcon, UserGroupIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline'
import Messages from "./AppPages/Messages";
import icon from "../icon.ico"
import Products from "./AppPages/Products";
import { Link, useNavigate } from 'react-router-dom';
import {doSignOut} from "../firebase/auth";
import OrderForm from "./AppPages/OrderForm";
import {useAuth} from "../contexts/AuthProvider";
import Transactions from "./AppPages/Transactions";
import Dashboard from "./AppPages/Dashboard";
import Customers from "./AppPages/Customers";
import { ReactComponent as LOGO } from "../Logo.svg";
import {onAuthStateChanged} from "firebase/auth";
import {auth} from "../firebase/firebase";
import ProductsPage from "./AppPages/ProductsPage";


const navigation = [
    // { name: 'Dashboard', href: '#', icon: HomeIcon, current: false },
    { name: 'Products', href: '#', icon: ClipboardDocumentListIcon, current: false },
    { name: 'Shopper Form', href: '#', icon: ShoppingCartIcon, current: false },
    { name: 'Transactions', href: '#', icon: CreditCardIcon, current: false },
    { name: 'Shoppers', href: '#', icon: UserGroupIcon, current: false },
    { name: 'Messages', href: 'Messages', icon: ChatBubbleLeftEllipsisIcon, current: false },
    // { name: 'Reports', href: '#', icon: ChartPieIcon, current: false },
]

const teams = [
    { id: 1, name: 'Paula Weinert', href: '#', initial: 'P', current: false },
    { id: 2, name: 'Spencer Wondolowski', href: '#', initial: 'S', current: false },
    { id: 3, name: 'Tom Weinert', href: '#', initial: 'T', current: false },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Content = () => {
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [selectedNav, setSelectedNav] = useState('Shopper Form');

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate("/");
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [navigate]);

    return (
        <>
            <div>
                <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
                    <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
                    />

                    <div className="fixed inset-0 flex">
                        <DialogPanel
                            transition
                            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
                        >
                            <TransitionChild>
                                <div
                                    className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                                    <button type="button" onClick={() => setSidebarOpen(false)}
                                            className="-m-2.5 p-2.5">
                                        <span className="sr-only">Close sidebar</span>
                                        <XMarkIcon aria-hidden="true" className="size-6 text-white"/>
                                    </button>
                                </div>
                            </TransitionChild>
                            {/* Sidebar component, swap this element with another sidebar if you like */}
                            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2">
                                <div className="flex h-16 shrink-0 items-center">
                                    <img
                                        alt="Your Company"
                                        src={icon}
                                        className="h-8 w-auto"
                                    />
                                </div>
                                <nav className="flex flex-1 flex-col">
                                    <ul role="list" className="flex flex-1 flex-col gap-y-7">
                                        <li>
                                            <ul role="list" className="-mx-2 space-y-1">
                                                {navigation.map((item) => (
                                                    <li key={item.name}>
                                                        <button
                                                            onClick={() => setSelectedNav(item.name)}
                                                            className={classNames(
                                                                item.name === selectedNav
                                                                    ? 'bg-gray-50 text-blue-600'
                                                                    : 'text-gray-700 hover:bg-gray-50 hover:text-blue-600',
                                                                'group flex w-full gap-x-3 rounded-md p-2 text-sm/6 font-semibold'
                                                            )}
                                                        >
                                                            <item.icon
                                                                aria-hidden="true"
                                                                className={classNames(
                                                                    item.name === selectedNav ? 'text-blue-600' : 'text-gray-400 group-hover:text-blue-600',
                                                                    'size-6 shrink-0'
                                                                )}
                                                            />
                                                            {item.name}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                        <li>
                                            <div className="text-xs/6 font-semibold text-gray-400">Your teams</div>
                                            <ul role="list" className="-mx-2 mt-2 space-y-1">
                                                {teams.map((team) => (
                                                    <li key={team.name}>
                                                    <a
                                                            href={team.href}
                                                            className={classNames(
                                                                team.current
                                                                    ? 'bg-gray-50 text-indigo-600'
                                                                    : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600',
                                                                'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                                                            )}
                                                        >
                                                              <span
                                                                  className={classNames(
                                                                      team.current
                                                                          ? 'border-indigo-600 text-indigo-600'
                                                                          : 'border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600',
                                                                      'flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium',
                                                                  )}
                                                              >
                                                                {team.initial}
                                                              </span>
                                                            <span className="truncate">{team.name}</span>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </DialogPanel>
                    </div>
                </Dialog>

                {/* Static sidebar for desktop */}
                <div className="hidden animate-slideInLeft lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-48 lg:flex-col">
                    {/* Sidebar component, swap this element with another sidebar if you like */}
                    <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6">
                        <div className="flex h-16 shrink-0 items-center">
                            <Link to={"/"}>
                                <img
                                    alt="Your Company"
                                    src={icon}
                                    className="h-8 w-auto"
                                />
                            </Link>
                        </div>
                        <nav className="flex flex-1 flex-col">
                            <ul role="list" className="flex flex-1 flex-col gap-y-7">
                            <li>
                                    <ul role="list" className="-mx-2 space-y-1">
                                        {navigation.map((item) => (
                                            <li key={item.name}>
                                                <Button
                                                    onClick={() => setSelectedNav(item.name)}
                                                    className={classNames(
                                                        item.name === selectedNav
                                                            ? 'bg-gray-50 text-blue-600'
                                                            : 'text-gray-700 hover:bg-gray-50 hover:text-blue-600',
                                                        'group flex w-full gap-x-3 rounded-md p-2 text-sm/6 font-semibold'
                                                    )}
                                                >
                                                    <item.icon
                                                        aria-hidden="true"
                                                        className={classNames(
                                                            item.name === selectedNav ? 'text-blue-600' : 'text-gray-400 group-hover:text-indigo-600',
                                                            'size-6 shrink-0'
                                                        )}
                                                    />
                                                    {item.name}
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                                <li>
                                    <div className="text-xs/6 font-semibold text-gray-400">Your teams</div>
                                    <ul role="list" className="-mx-2 mt-2 space-y-1">
                                        {teams.map((team) => (
                                            <li key={team.name}>
                                                <a
                                                    href={team.href}
                                                    className={classNames(
                                                        team.current
                                                            ? 'bg-gray-50 text-indigo-600'
                                                            : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600',
                                                        'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                                                    )}
                                                >
                          <span
                              className={classNames(
                                  team.current
                                      ? 'border-indigo-600 text-indigo-600'
                                      : 'border-gray-200 text-gray-400 group-hover:border-indigo-600 group-hover:text-indigo-600',
                                  'flex size-6 shrink-0 items-center justify-center rounded-lg border bg-white text-[0.625rem] font-medium',
                              )}
                          >
                            {team.initial}
                          </span>
                                                    <span className="truncate">{team.name}</span>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                                <li className="-mx-6 mt-auto">
                                    <div
                                        // href="#"
                                        className="flex items-center gap-x-4 px-6 py-3 text-sm/6 font-semibold text-gray-900 hover:bg-gray-50"
                                    >
                                        <LOGO className="size-8"/>

                                        <span className={`mr-auto`} aria-hidden="true">Internal Account</span>

                                        <Button
                                            // to={"/login"}
                                            onClick={() => {
                                                doSignOut().then(() => {
                                                    navigate('/login');
                                                });
                                            }}
                                        >
                                            <ArrowRightEndOnRectangleIcon className={`text-red-500 size-6 hover:animate-heartbeat`}/>
                                        </Button>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-sm sm:px-6 lg:hidden">
                    <button type="button" onClick={() => setSidebarOpen(true)}
                            className="-m-2.5 p-2.5 text-gray-700 lg:hidden">
                        <span className="sr-only">Open sidebar</span>
                        <Bars3Icon aria-hidden="true" className="size-6"/>
                    </button>
                    <div className="flex-1 text-sm/6 font-semibold text-gray-900">Dashboard</div>
                    <div className={`flex items-center`}>
                        <span className="sr-only">Your profile</span>
                        <Link to={"/"}>
                            <img
                                alt=""
                                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                className="size-8 rounded-full bg-gray-50 mr-3"
                            />
                        </Link>

                        <Button
                            // to={"/login"}
                            onClick={() => {
                                doSignOut().then(() => {
                                    navigate('/login');
                                });
                            }}
                        >
                        <ArrowRightEndOnRectangleIcon className={`text-red-500 size-6 hover:animate-heartbeat`}/>
                        </Button>
                    </div>
                </div>

                <main className="lg:pl-48 bg-gray-200 h-dvh">
                    <div className="animate-slideInRight w-full h-full">
                        {selectedNav === 'Dashboard' && <Dashboard/>}
                        {selectedNav === 'Products' && <ProductsPage/>}
                        {/*{selectedNav === 'Products' && <Products/>}*/}
                        {selectedNav === 'Shopper Form' && <OrderForm/>}
                        {selectedNav === 'Messages' && <Messages/>}
                        {/*{selectedNav === 'Reports' && <Reports/>}*/}
                        {selectedNav === 'Transactions' && <Transactions/>}
                        {selectedNav === 'Shoppers' && <Customers/>}
                    </div>
                </main>

            </div>
        </>
    )
}

export default Content
